import axios from "axios";

// Backend: pasta ./api (nexia-luck-api). Porta padrão 3500 (api/.env -> PORT).
// Em build/deploy, defina VUE_APP_API_URL para apontar pra outra origem.
const api = axios.create({
  // Em producao o front e a API sao servidos pelo mesmo host (nginx -> container),
  // entao baseURL vazio faz as chamadas irem para a propria origem. Em dev, a API
  // roda em 3500 e VUE_APP_API_URL aponta para la.
  baseURL: process.env.VUE_APP_API_URL ?? "http://localhost:3500",
  timeout: 8000,
  // O cookie de sessao e httpOnly: sem isto o browser nao o envia.
  withCredentials: true,
});

// Ambiente (produção x homologação). O backend guarda cada um num schema
// separado do banco (api/src/db.js), mas quem decide qual esta ativo e' um
// interruptor unico no servidor (meta.settings.current_env, trocado junto
// com o arquivo agent-env do agente por api/set-current-env.js) -- nunca o
// navegador. O front so EXIBE, via /current-env; nao existe mais escolha
// nem X-Ambiente indo em cada chamada.
export async function getCurrentEnv() {
  const { data } = await api.get("/current-env");
  return data.ambiente === "prod" ? "prod" : "hml";
}

// Sessao expirada ou ausente: avisa o App para voltar a tela de login em vez de
// deixar a tela quebrada com dados pela metade.
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response && err.response.status === 401) {
      window.dispatchEvent(new CustomEvent("nexia:unauthenticated"));
    }
    return Promise.reject(err);
  }
);

export async function login(email, password) {
  const { data } = await api.post("/auth/login", { email, password });
  return data.user;
}

export async function logout() {
  await api.post("/auth/logout");
}

/** Devolve o usuario da sessao, ou null se nao houver. */
export async function me() {
  try {
    const { data } = await api.get("/auth/me");
    return data.user;
  } catch {
    return null;
  }
}

function toISO(date) {
  const d = new Date(date);
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

function rangeParams(range, agent, base) {
  const params = { start: toISO(range.start), end: toISO(range.end) };
  if (agent) params.agent = agent;
  if (base) params.base = base;
  return params;
}

export async function getAgents() {
  const { data } = await api.get("/agents");
  return data;
}

// As 7 bases (recife/natal/joao_pessoa/maceio/salvador/aracaju/noronha) pro
// seletor do front. hasCvc=false (aracaju, noronha) -> mostra "sem dados".
export async function getBases() {
  const { data } = await api.get("/bases");
  return data;
}

// Botao "Executar agora": grava a solicitacao; o poller do agente pega e roda.
// period = { dataInicial, dataFinal } em DD/MM/YYYY — so o pipeline usa.
export async function runAgent(subAgentKey, base, period) {
  const body = { ...(base ? { base } : {}), ...(period || {}) };
  const { data } = await api.post(`/agents/${subAgentKey}/run`, body);
  return data;
}

export async function getIndicators(range, agent, base) {
  const { data } = await api.get("/indicators", {
    params: rangeParams(range, agent, base),
  });
  return data;
}

export async function getExecutions(subAgentKey, range, base) {
  const { data } = await api.get(`/subagents/${subAgentKey}/executions`, {
    params: { start: toISO(range.start), end: toISO(range.end), ...(base ? { base } : {}) },
  });
  return data;
}

export async function getExecutionLogs(executionId) {
  const { data } = await api.get(`/executions/${executionId}/logs`);
  return data;
}

export async function getPendencies(range, agent, base) {
  const { data } = await api.get("/pendencies", {
    params: rangeParams(range, agent, base),
  });
  return data;
}

export async function getImportDetail(range, agent, base) {
  const { data } = await api.get("/import-detail", {
    params: rangeParams(range, agent, base),
  });
  return data;
}

export async function getVoucherLogs(voucher, base) {
  const { data } = await api.get("/import-detail/voucher-logs", {
    params: { voucher, ...(base ? { base } : {}) },
  });
  return data;
}

export async function getPendenciesDetail(range, agent, base) {
  const { data } = await api.get("/pendencies-detail", {
    params: rangeParams(range, agent, base),
  });
  return data;
}
